import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-phone-large',
  templateUrl: './icon-phone-large.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPhoneLargeComponent {}
